import { ParseQuery } from './parse-query';
import { Brand } from './../data';

export class BrandQuery extends ParseQuery<Brand> {
  constructor() {
    super(Brand.CLASS_NAME);
  }
}
